module.exports = __webpack_public_path__ + "static/media/poisson.fa72ee58.svg";